import { Component, OnInit } from '@angular/core';
import { Doctor } from '../../../core/models/doctor.model';
import { CommonModule } from '@angular/common';
import { F } from '@angular/cdk/keycodes';
import { FormsModule } from '@angular/forms';
import { SettingsService } from '../../../core/services/settings.service';
import { AppearanceSettings } from '../../../core/models/appearance-settings.model';
import { ClinicDoctorProfileDto } from '../../../core/models/clinic-doctor-profile.model';
import { NotificationService } from '../../../core/services/notification.service';
import { PermissionService } from '../../../core/services/permission.service';
import { HasRolePipe } from '../../../core/pipes/has-role.pipe';

@Component({
  selector: 'app-appearance-settings',
  imports: [CommonModule, FormsModule, HasRolePipe],
  templateUrl: './appearance-settings.html',
  styleUrl: './appearance-settings.scss',
})
export class AppearanceSettingsComponent implements OnInit {
  clinicDoctors: ClinicDoctorProfileDto[] = [];
  defaultDoctorName: string | null = null;
  isLoading = false;

  appearanceSettings: AppearanceSettings = {
    scheduleCalendarView: 'MONTH',
    defaultDoctorId: null,
  };

  constructor(
    private settingsService: SettingsService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.loadAppearanceSettings();
    this.loadDoctors();
  }

  private loadDoctors(): void {
    const doctors = localStorage.getItem('clinicDoctors');
    if (doctors) {
      this.clinicDoctors = JSON.parse(doctors);
      this.defaultDoctorName =
        this.clinicDoctors.filter(
          (doctor) => doctor.doctorId === this.appearanceSettings?.defaultDoctorId,
        )[0]?.firstName +
        ' ' +
        this.clinicDoctors.filter(
          (doctor) => doctor.doctorId === this.appearanceSettings?.defaultDoctorId,
        )[0]?.lastName;
    }
  }

  private loadAppearanceSettings(): void {
    this.settingsService.getAppearanceSettings().subscribe(
      (settings) => {
        this.appearanceSettings = settings;
        this.isLoading = false;
      },
      (error) => {
        this.notificationService.error('Failed to load appearance settings: ' + error.message);
        this.isLoading = false;
      },
    );
  }

  doctors: Doctor[] = [];

  saveAppearanceSettings(): void {
    this.isLoading = true;
    this.settingsService.updateAppearanceSettings(this.appearanceSettings!).subscribe(
      (updatedSettings) => {
        this.appearanceSettings = updatedSettings;
        this.isLoading = false;
      },
      (error) => {
        this.notificationService.error('Failed to save appearance settings: ' + error.message);
        this.isLoading = false;
      },
    );
  }

  get calendarViewLabel(): string {
    switch (this.appearanceSettings.scheduleCalendarView) {
      case 'DAY':
        return 'Day View';
      case 'WEEK':
        return 'Week View';
      default:
        return 'Month View';
    }
  }

  get selectedDoctorName(): string {
    if (!this.appearanceSettings.defaultDoctorId) {
      return 'All Doctors';
    }

    const doctor = this.clinicDoctors.find(
      (item) => item.doctorId === this.appearanceSettings.defaultDoctorId,
    );
    return doctor ? `Dr. ${doctor.firstName} ${doctor.lastName}` : 'Selected Doctor';
  }
}
